/* global axios */

import ApiClient from './ApiClient';

// Os fluxos em que um contato está. "Essa pessoa respondeu, tira ela de tudo"
// começa olhando a PESSOA, não o fluxo — por isso a ação mora aqui também.
class ContactWorkflowsAPI extends ApiClient {
  constructor() {
    super('contact_workflows', { accountScoped: true });
  }

  forContact(contactId) {
    return axios.get(this.url, { params: { contact_id: contactId } });
  }

  // Sem workflowId, tira de todos os fluxos em que a pessoa estiver.
  stop(contactId, workflowId = null) {
    return axios.post(`${this.url}/stop`, {
      contact_id: contactId,
      workflow_id: workflowId,
    });
  }
}

export default new ContactWorkflowsAPI();
